import { action, observable } from "mobx";
import { api_adm } from "../../api";
import { ILegisWebLucro, ILegisWebSimples } from "../../model";
import { toast } from "react-toastify";

export class _LegisWebStore {


  obs = observable({
    legisweb_simples: [] as ILegisWebSimples[],
    viewSimplesDetalhes: false as boolean,
    lengthProduto: 0 as number,
    legisweb_lucro: [] as ILegisWebLucro[],
    viewLucroDetalhes: false as boolean,
    lengthLucroProduto: 0 as number
  })

  constructor() {
  }

  @action
  async legisWebSimplesLoad(page: number): Promise<void> {
    try {
      let resp = await api_adm.get(`/api/admin/lista-legisweb/${page}`);

      this.obs.legisweb_simples = [];
      this.obs.lengthProduto = resp.data.total;
      this.obs.legisweb_simples = resp.data.itens

    } catch (ex) {
      toast.error("Erro ao carregar Legis Web!", {});
    }
  }

  async buscaNcmSimples(ncm: string) {
    try {

      let resp = await api_adm.get(`/api/admin/filtra-legisweb/${ncm}`);

      this.obs.legisweb_simples = [];
      this.obs.legisweb_simples = resp.data.itens

    } catch (ex) {
      toast.error("Erro ao filtrar Legis Web!", {});
    }
  }

  @action
  async legisWebLucroLoad(page: number): Promise<void> {
    try {

      let resp = await api_adm.get(`/api/admin/lista-legisweb-lucro/${page}`);

      this.obs.legisweb_lucro = [];
      this.obs.lengthLucroProduto = resp.data.total;
      this.obs.legisweb_lucro = resp.data.itens

    } catch (ex) {
      toast.error("Erro ao carregar Legis Web Lucro!", {});
    }
  }

  async buscaNcmLucro(ncm: string) {
    try {

      let resp = await api_adm.get(`/api/admin/filtra-legisweb-lucro/${ncm}`);

      this.obs.legisweb_lucro = [];
      this.obs.legisweb_lucro = resp.data.itens

    } catch (ex) {
      toast.error("Erro ao filtrar Legis Web Lucro!", {});
    }
  }

  async handleDuplicar(data) {

    try {

      let resp = await api_adm.post(`/api/admin/legisweb/duplicate`, data);

      if (resp.data.ok) {

        toast.success("Legis Web duplicado com sucesso!", {});
        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {
      toast.error("Erro ao duplicar Legis Web, tente novamente mais tarde!", {});
    }

    return false

  }

  async handleDelete(id: string) {

    try {

      let resp = await api_adm.delete(`/api/admin/legisweb/${id}`);

      if (resp.data.ok) {

        toast.success("Legis Web deletado com sucesso!", {});
        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {
      toast.error("Erro ao deletar Legis Web, tente novamente mais tarde!", {});
    }

    return false

  }

}

export const LegisWebStore = new _LegisWebStore();
